import React from "react";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import About from "@/components/landing/About";
import MisionVision from "@/components/landing/MisionVision";
import Distintivos from "@/components/landing/Distintivos";
import Servicios from "@/components/landing/Servicios";
import Proyectos from "@/components/landing/Proyectos";
import Contacto from "@/components/landing/Contacto";
import Footer from "@/components/landing/Footer";
import useInView from "@/hooks/useInView";

export default function LandingPage() {
    useInView();
    return (
        <main
            data-testid="landing-page"
            className="bg-cream text-navy font-body relative"
        >
            <Navbar />
            <Hero />
            <Marquee />
            <About />
            <MisionVision />
            <Distintivos />
            <Servicios />
            <Proyectos />
            <Contacto />
            <Footer />
        </main>
    );
}
